import { ApiResponseData } from "@/types/api";

interface Headers {
  [key: string]: string | string[] | number | boolean | null;
}

export class ApiError<T = any> extends Error {
  code: number | undefined;
  response?: {
    data: any;
    status: number | null;
    statusText: string | null;
    headers: Headers | null;
  };
  config?: {
    url: string | null;
    method: string | null;
    data: any | null;
    params: any | null;
    headers: Headers | null;
  };

  constructor(message: string, code?: number, response?: any | null, request?: any | null) {
    super(message);
    this.name = 'ApiError';
    this.code = code !== undefined ? Number(code) : undefined;
    this.config = {
      url: request?.url ?? null,
      method: request?.method ?? null,
      data: request?.data ?? null,
      params: request?.params ?? null,
      headers: request?.headers ?? null,
    };
    this.response = {
      data: response?.data ?? null,
      status: response?.status ?? null,
      statusText: response?.statusText ?? null,
      headers: response?.headers ?? null,
    };
  }
}

export const checkApiResponse = <T>(response: ApiResponseData<T>, request?: any): T => {
  if (response.code !== 0 || response.data === undefined) {
    throw new ApiError(response.message || 'Unknown error', response.code, response, request);
  }
  return response.data;
};

export const isApiErrorWithCode = (
  error: Error | unknown,
  code?: number | number[],
): error is ApiError => {
  if (!(error instanceof ApiError)) {
    return false;
  }

  if (code === undefined) {
    return true;
  }

  if (Array.isArray(code)) {
    return code.includes(error.code || 0);
  }

  return error.code === code;
};
